import { FC, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AssertionsSetsListWidget } from './AssertionSetsWidget';
import { AssertionsListWidget } from './Details';

export const AssertionWidget: FC = () => {
	const [searchParams] = useSearchParams();
	const assetionId = useMemo(() => searchParams.get('assertion-set-id') || '', [searchParams]);

	if (assetionId) {
		return <AssertionsListWidget assetionId={assetionId} />;
	}
	return <AssertionsSetsListWidget />;
};
